import React, { useEffect } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import {
	DocumentType,
	useDocumentsQuery,
	useGetUserOriginalIdQuery,
} from '../../../../graphql/graphql';
import { useFlatDataList } from '../../../Base/Hooks/useFlatDataList';
import DataMover from '../../../Base/Components/DataMover/DataMover';
import { DataMoverType } from '../../../Base/Enums/DataMoverType.enum';
import Loading from '../../../../Components/Loading';
import { DiscourseItem } from '../DiscourseHistory/DiscourseHistoryItem';
import DiscourseSelectItem from './DiscourseSelectItem';

interface Props {
	patientId: string;
	workplaceId: string;
	onSubmit: (item: DiscourseItem) => void;
}

const DiscourseSelectList: React.FC<Props> = ({
	patientId,
	workplaceId,
	onSubmit,
}) => {
	const { data: userData } = useGetUserOriginalIdQuery({ id: patientId });
	const originalId = userData?.user?.originalId;

	const { pagination, appendData, flatData, getNextPage } =
		useFlatDataList<DiscourseItem>({}, 10);
	const { data, isLoading } = useDocumentsQuery(
		{
			userId: originalId,
			workplaceId,
			types: [DocumentType.Dekurz, DocumentType.DekurzDraft],
			skip: pagination.skip,
		},
		{ skip: !originalId, refetchOnMountOrArgChange: true },
	);

	useEffect(() => {
		appendData((data?.documents?.data as DiscourseItem[]) ?? []);
	}, [data]);

	if (isLoading) {
		return <Loading />;
	}

	return (
		<DataMover<DiscourseItem>
			data={flatData}
			type={DataMoverType.SINGLE}
			onSubmit={onSubmit}
			hasMoreData={Boolean(data?.documents?.meta?.hasNextPage)}
			getNextPage={getNextPage}
			renderItem={item => <DiscourseSelectItem key={item.id} item={item} />}
		/>
	);
};

export default DiscourseSelectList;
